// src/components/BannerHome.js
import '../assets/css/Main.css';
import '../assets/css/responsive.css';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const BannerHome = ({ sliderList }) => {
  const isLoading = !sliderList || sliderList.length === 0;
  const isEmpty = Array.isArray(sliderList) && sliderList.length === 0;

  return (
    <div className='home_carousel banner-section'>
      {isLoading ? (
        <div className="row">
          {[...Array(1)].map((_, i) => (
            <div className="col-12 mb-4" key={i}>
              <div className="banner-skeleton skeleton-banner"></div>
            </div>
          ))}
        </div>
      ) : isEmpty ? (
        <div className="text-center py-5">
          <img
            src="/images/empty-state.png"
            alt="No banners"
            style={{ maxWidth: '250px', marginBottom: '20px' }}
          />
          <h5>No banners available</h5>
          <p>Please check back later.</p>
        </div>
      ) : (
        <Swiper
          modules={[Navigation, Pagination, A11y, Autoplay]}
          slidesPerView={1.4}
          spaceBetween={10}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          }}
          pagination={{
            el: '.swiper-pagination',
            clickable: true,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            767: { slidesPerView: 1.2 },
            992: { slidesPerView: 1.4 },
          }}
          className="bannerCarousel"
        >
          {sliderList.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="carousel_box common-width text-md-end d-flex align-items-center position-relative">
                <div className="hero-banner-img">
                  <img src={slide.image} className="w-100" alt={`Banner ${slide.id}`} />
                </div>
                <div className="content_box position-absolute z-2">
                  <h1 className="title">Join Hands, Make a Difference</h1>
                  <a href={slide.link || '#'} className="btn btn-primary py-2">Donate Now</a>
                </div>
              </div>
            </SwiperSlide>
          ))}

          <div className="pagination_nav">
            <div className="swiper-next">›</div>
            <div className="swiper-prev">‹</div>
          </div>
          <div className="swiper-pagination"></div>
        </Swiper>
      )}
    </div>
  );
};

export default BannerHome;
